import { getCookie, setCookie } from '@beef/utils';
import { IS_START_ANSWER_MES } from "./constants";
export var getHref = function getHref() {
  return typeof window !== 'undefined' ? window.location.href : null;
};
export var executeIfTrue = function executeIfTrue(predicat, cb) {
  return function (args) {
    if (predicat()) {
      cb(args);
    }
  };
};
export var setStageAnswerMes = function setStageAnswerMes() {
  var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  setCookie({
    name: IS_START_ANSWER_MES,
    value: stage
  });
};
export var getIsNonStartAnswerMes = function getIsNonStartAnswerMes() {
  return !!getCookie(IS_START_ANSWER_MES);
};